import React, { Component } from 'react';
import PropTypes from 'prop-types';

import branch from 'client/core/branch';
import UserActions from 'client/actions/User';

@branch()
class SrEducationalSearchCard extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    currentUserMarket: PropTypes.object.isRequired,
  };

  _onCloseButtonClick = (event) => {
    event.preventDefault();
    event.stopPropagation();

    this.props.dispatch(UserActions.updateSettings, {
      educationalSearchCardClosed: true,
    });
  };

  render() {
    const { currentUserMarket } = this.props;
    return (
      <div className="promptCard educationalSearch">
        <div className="textContainer">
          <span className="category">tour any address</span>
          <span className="headline">
            Tour any home in {currentUserMarket.displayName} with Sunroom!
          </span>
          <span className="subhead">
            Sunroom has realtors that can open the door to any rental property in{' '}
            {currentUserMarket.displayName}
            <span role="img" aria-label="house">
              {' '}
              🏡
            </span>
          </span>
        </div>
        <div onClick={this._onCloseButtonClick} className="buttonContainer">
          <span className="button white small">OK, got it!</span>
        </div>
      </div>
    );
  }
}

SrEducationalSearchCard.displayName = 'SrEducationalSearchCard';

export default SrEducationalSearchCard;
